import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';


// handle Rtl
export const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

export let CustomTheme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 991,
            lg: 1200,
            xl: 1536,
        },
    },
    direction: 'rtl',
    spacing: 8,
    palette: {
        primary: {
            main: '#CEC19F',
        },
        grey: {
            main: 'rgba(238, 238, 238, 0.93)',
        },
        secondary: {
            main: '#16423C'
        },
        btnGrey: {
            main: '#E7E7E7',
        },
        badgeGrey: {
            main: '#B5B5B5',
        },
        background: {
            gray: '#F7F7F7',
            paper: '#F7F7F7',
        },
        text: {
            primary: '#262745',
            secondary: '#656565',
            white: '#fff',
            dark: "#000"
        },
        borderColor: {
            primary: '#EEE',
            secondary: 'red',
            form: "#B5B5B5"
        }
    },
    // shape: {
    //     borderRadius: 10,
    // },
    typography: {
        htmlFontSize: 16,
        fontSize: 14,
        fontFamily: 'inherit',
        h3: {
            fontSize: '32px',
        },
        h4: {
            fontSize: '18px',
        },
        h5: {
            fontSize: '14px',
        },
        body1: {
            fontSize: "16px",
        },
        body2: {
            fontSize: "14px",
        },
        caption: {
            fontSize: "12px",
        }
    },

    shadows: [
        'none',
        '0px 2px 4px rgba(0, 0, 0, 0.25)',
        '0px 0px 14px 0px rgba(29, 43, 71, 0.50)',
        '0px 4px 10px 0px #0000001A',
        '0px 4px 10px 0px #0000001A',
        '0px 1px 1px rgba(0, 0, 0, 0.10)',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
    ],

    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: 'unset',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    outline: 'unset !important',
                    '&:focus': {
                        outline: 'unset !important',

                    },
                    ...(ownerState.variant === 'contained' && {
                        color: '#fff !important',
                        outline: 'unset !important',
                        boxShadow: 'none',
                        fontSize: '16px',
                        fontWeight: "bold",
                        [CustomTheme.breakpoints.down('md')]: {
                            fontSize: '14px',
                        },

                    }),
                    ...(ownerState.variant === 'outlined' && {
                        color: CustomTheme.palette.primary.main,
                        outline: 'unset !important',
                        boxShadow: 'none',
                        padding: '12px 24px',
                        fontSize: '16px',
                        fontWeight: "bold",
                        [CustomTheme.breakpoints.down('md')]: {
                            fontSize: '14px',

                        },

                    }),

                }),
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(ownerState.variant === 'filled' && {
                        backgroundColor: 'transparent',

                    }),
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: CustomTheme.palette.borderColor.form,
                        },
                    }
                }),
            },
        },



    },


});

CustomTheme = responsiveFontSizes(CustomTheme)